import React, { useEffect } from "react";
import styles from "./MisTableComponent.module.scss";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { commonVaribles } from "src/constants/constVariables";
import { Loader } from "../Loader";

const Arraow = ({ title }) => {
  return (
    <div style={{ display: "flex", gap: "0.5rem" }}>
      {title}
      <ArrowForwardIcon />
    </div>
  );
};

export default function MisTableComponent({
  headerInfo,
  rowData,
  isheaderColor,
  iscount,
}) {
  const rows = rowData;
  const headerData = [
    {
      header: <Arraow title={headerInfo.title} />,
      data: headerInfo.data,
      width: headerInfo.width,
    },
  ];

  useEffect(() => {
    synchronizeRowHeights();
  }, []);

  const synchronizeRowHeights = () => {
    const leftRows = document.querySelectorAll(
      `.${styles.tableContainerLeftSideDiv} tbody tr`
    );
    const rightRows = document.querySelectorAll(
      `.${styles.tableContainerRightSideDiv} tbody tr`
    );

    leftRows.forEach((leftRow, index) => {
      const rightRow = rightRows[index];
      if (leftRow && rightRow) {
        const leftRowHeight = leftRow.clientHeight;
        const rightRowHeight = rightRow.clientHeight;
        const maxHeight = Math.max(leftRowHeight, rightRowHeight);

        leftRow.style.height = `${maxHeight}px`;
        rightRow.style.height = `${maxHeight}px`;
      }
    });
  };

  return rows.length !== 0 ? (
    <div>
      <div className={styles.tableContainer}>
        <table
          className={
            isheaderColor
              ? styles.tableContainerLeftSideDivConditional
              : styles.tableContainerLeftSideDiv
          }
        >
          <thead>
            <tr>
              <td
                style={{ width: "50px" }}
                className={
                  iscount ? styles.firstTwoColumnsHeader : styles.counts
                }
              >
                #
              </td>
              <td
                style={{ width: headerData[0].width }}
                className={styles.firstTwoColumnsHeader}
              >
                {headerData[0].header}
              </td>
            </tr>
          </thead>
          <tbody>
            {[...Array(headerData[0].data.length)].map((_, rowIndex) => (
              <tr key={rowIndex}>
                <td
                  className={
                    iscount
                      ? isheaderColor
                        ? styles.firstTwoColumnsConditional
                        : styles.firstTwoColumns
                      : styles.counts
                  }
                >
                  {rowIndex + 1}
                </td>
                <td
                  className={
                    isheaderColor
                      ? styles.firstTwoColumnsConditional
                      : styles.firstTwoColumns
                  }
                >
                  {headerData[0].data[rowIndex]}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div
          className={
            isheaderColor
              ? styles.tableContainerRightSideDiv
              : styles.tableContainerRightSideDivHeader
          }
        >
          <table className={styles.tableContainerRightSideDiv}>
            <thead className={isheaderColor ? styles.headersList : ""}>
              <tr>
                { typeof rows == "object" && rows.map((column, index) => (
                  <th
                    key={index}
                    style={{ width: column.width }}
                    className={styles.headerCell}
                  >
                    {column.header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className={isheaderColor ? styles.tableBody : {}}>
              {[...Array(headerData[0].data.length)].map((_, rowIndex) => (
                <tr key={rowIndex}>
                  { typeof rows == "object" && rows.map((column, colIndex) => {
                    const header = headerData[0].data[rowIndex];
                    const keys = Object.values(column);
                    const rowData = keys[1];
                    const headerKeys = Object.keys(rowData);
                    const cellData = headerKeys.includes(header)
                      ? rowData[header]
                      : "-";

                    return (
                      <td
                        key={colIndex}
                        style={{ width: column.width }}
                        className={styles.dataCell}
                      >
                        {cellData}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  ) : (
    <div className={styles.container}><Loader/></div>
  );
}
